import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const StainSchema = BaseSchema.extend({
  name: z.string().max(255),
  shortcut: z.string().max(255),
});

export type Stain = z.infer<typeof StainSchema>;

export const StainEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: StainSchema,
});

export type StainEntityQueryResult = z.infer<typeof StainEntityQueryResultSchema>;
